/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Driver Filled Icon component.
 */
export const SystemDriverFilledIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M11.8705 10.7584C14.0866 10.7584 15.8832 9.02164 15.8832 6.87921C15.8832 4.73678 14.0866 3 11.8705 3C9.65442 3 7.85791 4.73678 7.85791 6.87921C7.85791 9.02164 9.65442 10.7584 11.8705 10.7584Z' fill={iconColor} />
      <path d='M3 17.1738C3 14.9647 4.79086 13.1738 7 13.1738H16.0009C18.21 13.1738 20.0009 14.9647 20.0009 17.1738V20.5003C20.0009 20.7765 19.777 21.0003 19.5009 21.0003H3.5C3.22386 21.0003 3 20.7765 3 20.5003V17.1738Z' fill={iconColor} />
    </svg>
  );
};

export default SystemDriverFilledIcon;
